/**
 * @generated SignedSource<<d6a81f03d65c93cae6a2d2f190c97c93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactDesignerModal_tradeFirm$data = {
  readonly publicProfile: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentType": "ContactDesignerModal_tradeFirm";
};
export type ContactDesignerModal_tradeFirm$key = {
  readonly " $data"?: ContactDesignerModal_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDesignerModal_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactDesignerModal_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "3f263094306f61e1e3228a0ba6f46366";

export default node;
